import React from 'react'
import Icons from '../Icons'
import Tooltip from '@/components/Tooltip'

function TryAgainBtn() {
  return (
    <Tooltip
      info={{
        content: 'Try again',
        placement: 'top',
      }}
    >
      <div
        style={{
          width: '28px',
          height: '28px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#fff',
          borderRadius: '50%',
          cursor: 'pointer',
        }}
      >
        <Icons.TryAgainIcn />
      </div>
    </Tooltip>
  )
}

export default TryAgainBtn
